import React from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { TandemConstants } from "@/lib/drivers/tandem/TandemConstants.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";

export type TandemSearchButtonProps = {
  className?: string;
};

export const TandemSearchButton: React.FC<TandemSearchButtonProps> = ({ className }) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  return (
    <Button
      variant="contained"
      className={cx(styles.container, className)}
      onClick={async () => {
        const device = await navigator.serial.requestPort({
          filters: [
            {
              usbVendorId: TandemConstants.VENDOR_ID,
              usbProductId: TandemConstants.PRODUCT_ID,
            },
          ],
        });
        console.info(device);
      }}
    >
      {t("devices.tandem.searchForDevice")}
    </Button>
  );
};

const makeStyles = () => ({
  container: css({}),
});
